module.exports = __webpack_public_path__ + "img/clos-luce-kitchen.d57d0878.jpeg";